import { useAnalytics } from "$global-providers/analytics-provider/provider";
import { useServiceWorker } from "$global-providers/service-worker-provider/provider";
import { styled, Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import { WarningBanner } from "./warning-banner";

const LinkButton = styled("button")({
  background: "none",
  color: "blue",
  border: "none",
  padding: 0,
  font: "inherit",
  cursor: "pointer",
  outline: "inherit",
  textDecoration: "underline",
});

export const AppOutOfDateBanner = () => {
  const { updateAndRefresh } = useServiceWorker();
  const { trackEvent } = useAnalytics();

  if (!updateAndRefresh) return null;

  const onClickUpdate = () => {
    trackEvent("appOutOfDateBannerUpdateClicked", {
      updateSource: "serviceWorker",
    });
    updateAndRefresh();
  };

  return (
    <WarningBanner data-testid="app-out-of-date-banner">
      <Typography>
        <FormattedMessage
          id="appOutOfDateBanner"
          defaultMessage="Elephant has been updated. Please <link>refresh</link> to use the latest version."
          values={{
            link: (text: React.ReactNode) => (
              <LinkButton type="button" onClick={onClickUpdate}>
                {text}
              </LinkButton>
            ),
          }}
        />
      </Typography>
    </WarningBanner>
  );
};
